import React from "react";

import AuditTrail from "../audit.trail";

export const ModalLog = (WrappedComponent) => (props) => {
  const { onAfterOpen, onRequestClose, event, eventParams, ...otherProps } = props;

  const onLog = (event, action, eventParams) => {
      if (event && action) {
          let data = Object.assign({tag: 'modal', event: action, label: props.label? props.label : ''}, eventParams);
          AuditTrail.sendLog(event, data);
      }
  }

  return (
    <WrappedComponent
        {...otherProps}
        onAfterOpen={(context) => {
            onLog(event, 'openModal', eventParams);
            if (props.onAfterOpen) {
                props.onAfterOpen(context);
            }
        }}
        onRequestClose={(context) => {
            onLog(event, 'closeModal', eventParams);
            if (props.onRequestClose) {
                props.onRequestClose(context);
            }
        }}
    />
  );
};
